// Fetches a fresh presigned stream URL for a tutorial video. This hits our
// own JSON endpoint (not a redirect) so the browser never opens a second,
// unused connection to the video body itself — only the <video> element's
// own range-request streaming touches S3.
const fetchStreamUrl = async (videoId) => {
    const response = await fetch(`/knowledge_hub/tutorials/${videoId}/stream_video`);
    const { url } = await response.json();
    return url;
};

// If the presigned S3 URL expires while a video is loaded (e.g. left paused
// for a while), the <video> element fires an `error` event instead of
// playing. This re-fetches a fresh URL and resumes from the same position
// instead of leaving the viewer with a dead player.
const attachStreamRecovery = (videoEl, getVideoId) => {
    let isRecovering = false;
    let shouldBePlaying = false;

    videoEl.addEventListener('play', () => { shouldBePlaying = true; });
    videoEl.addEventListener('pause', () => { shouldBePlaying = false; });

    videoEl.addEventListener('error', async () => {
        if (isRecovering || !videoEl.src) {
            return;
        }

        const videoId = getVideoId();
        if (!videoId) {
            return;
        }

        isRecovering = true;
        const resumeAt = videoEl.currentTime;

        try {
            videoEl.src = await fetchStreamUrl(videoId);
            videoEl.currentTime = resumeAt;
            if (shouldBePlaying) {
                await videoEl.play();
            }
        } catch (refreshError) {
            console.error('Error refreshing expired stream URL:', refreshError);
        } finally {
            isRecovering = false;
        }
    });
};

document.addEventListener('turbolinks:load', () => {
    if ($('.knowledge-hub .tutorials-listing').length === 0 && $('.knowledge-hub.show').length === 0) {
        return false
    }

    const modalEl = document.getElementById('videoStreamingModal');
    if (modalEl) {
        const videoEl = document.getElementById('modalVideo');
        const closeBtn = modalEl.querySelector('.btn-close');
        const bsModal = new bootstrap.Modal(modalEl)

        attachStreamRecovery(videoEl, () => videoEl.dataset.videoId);

        // When a thumbnail is clicked
        document.querySelectorAll('.video-thumbnail').forEach(thumb => {
            const thumbnailSection = thumb.parentElement
            thumbnailSection.addEventListener('click', async (e) => {
                const videoId = thumbnailSection.dataset.id;

                // Set the video source and open modal
                videoEl.dataset.videoId = videoId;
                videoEl.src = await fetchStreamUrl(videoId);
                bsModal.show();
                videoEl.play();
            });
        });

        // Close modal
        closeBtn.addEventListener('click', () => {
            bsModal.hide()
        })

        // Close modal
        modalEl.addEventListener('hidden.bs.modal', () => {
            videoEl.pause()
            videoEl.removeAttribute('src')
            videoEl.load()
            delete videoEl.dataset.videoId
        })
    }

    // Show page video streaming
    const videoWrapper = document.querySelector('.video-wrapper');
    const showPageVideo = document.getElementById('showPageVideo');
    const previewOverlay = document.querySelector('.video-preview-overlay');

    if (videoWrapper && showPageVideo && previewOverlay) {
        attachStreamRecovery(showPageVideo, () => videoWrapper.dataset.id);

        previewOverlay.addEventListener('click', async () => {
            const videoId = videoWrapper.dataset.id;

            // Show loading state if needed
            previewOverlay.style.opacity = '0.5';
            previewOverlay.style.pointerEvents = 'none';

            try {
                showPageVideo.src = await fetchStreamUrl(videoId);

                // Hide overlay and play
                previewOverlay.style.display = 'none';
                showPageVideo.play();
            } catch (error) {
                console.error('Error fetching stream URL:', error);
                previewOverlay.style.opacity = '1';
                previewOverlay.style.pointerEvents = 'auto';
            }
        });
    }
});
